const avaliableSports = [
  'soccer-ball',
  'nfl',
  'basketball',
  'baseball',
  'tennis-ball',
  // 'golf',
  'hockey',
  // 'rugby',
  // 'volleyball',
  // 'ping-pong',
  'NFL',
  'NBA',
  'SOC',
  // 'NCAA',
  'MLB',
  'NHL',
  // 'CFB'
];

const drawAbleSports = ['SOC', 'soccer-ball', 'baseball', 'MLB', 'NFL', 'nfl', 'rugby'];

const halfTimeSports = ['SOC', 'soccer-ball'];

export default class statscoreHelper {
  constructor() {
    this.avaliableSports = avaliableSports;
    this.drawAbleSports = drawAbleSports;
    this.halfTimeSports = halfTimeSports;
    this.currentSport = null;
  }

  setCurrentSport(value) {
    this.currentSport = value;
  }

  isAvaliable() {
    return this.avaliableSports.includes(this.currentSport);
  }

  isDrawable() {
    return this.drawAbleSports.includes(this.currentSport);
  }

  isHalfTimeAvaliable() {
    return this.halfTimeSports.includes(this.currentSport);
  }
}
